<!-- Nested Table: level 1 loads on Generate; deeper TABLE queries load when
     their parent row is expanded. -->
<div class="wf-section" *ngIf="active">
  <header class="wf-section-header">
    <h3>{{ host.layoutSectionTitle('nestedTable', 'Nested table') }}</h3>
  </header>
  <small class="control-hint" *ngIf="host.layoutSectionHint('nestedTable')">
    {{ host.layoutSectionHint('nestedTable') }}
  </small>

  <!-- Nested is a Table type: the same picker switches back to the others. -->
  <div class="control-group">
    <label>{{ host.fieldLabel('tableMatrix', 'tableType', 'Table type') }}</label>
    <ng-select
      #ssNestedType
      class="ss-select"
      [class.is-open]="!!ssNestedType.isOpen?.()"
      appendTo="body"
      ngClass="ss-dropdown-panel"
      [items]="tableTypes"
      bindLabel="label"
      bindValue="value"
      groupBy="group"
      [clearable]="false"
      [ngModel]="'nested'"
      (ngModelChange)="onTableTypeChange($event)"
    ></ng-select>
  </div>

  <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>

  <div class="control-row">
    <div class="control-group">
      <label>{{ host.fieldLabel('nestedTable', 'subtitle', 'Subtitle') }}</label>
      <input type="text" [(ngModel)]="subtitle" (ngModelChange)="onFieldChange()" placeholder="Optional" />
    </div>
    <div class="control-group">
      <label>{{ host.fieldLabel('nestedTable', 'rowsKey', 'Rows path in response') }}</label>
      <input type="text" [(ngModel)]="rowsKey" (ngModelChange)="onFieldChange()" placeholder="Leave blank for the root" />
    </div>
  </div>

  <div class="control-group control-group-full">
    <label>Levels</label>
    <small class="control-hint">
      Up to {{ maxLevels }}. Leave Columns empty to show every column the rows carry.
    </small>

    <div class="nested-level-card" *ngFor="let level of levels; let i = index; trackBy: trackLevel">
      <div class="nested-level-header">
        <span>Level {{ i + 1 }}</span>
        <button
          type="button"
          class="nested-level-remove"
          *ngIf="levels.length > 1"
          (click)="removeLevel(i)"
          title="Remove this level"
          attr.aria-label="Remove level {{ i + 1 }}"
        >&times;</button>
      </div>

      <div class="nested-level-field">
        <label>Title</label>
        <input type="text" [(ngModel)]="level.title" (ngModelChange)="onFieldChange()" />
      </div>

      <div class="nested-level-field" *ngIf="i > 0">
        <label>Filter by parent row</label>
        <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="parentFields(level)" [multiple]="true" [closeOnSelect]="false" [clearable]="true" placeholder="Columns of the row you expand" [ngModel]="level.parentKeys" (ngModelChange)="setParentKeys(level, $event)"></ng-select>
        <small class="control-hint">Each column picked is sent as a filter with the value of the row you click, e.g. customer = Komatsu and segment = Heavy Duty.</small>
      </div>

      <!-- Columns at this level — ONE row per column, each with its own
           Dataset picker ("Same as primary" by default), like the Normal
           table's column cards: a column may read from ANOTHER dataset (the
           backend joins on the {dataset, field} contract). Leave the list
           empty to show every column the rows carry. Drag a field from the
           data pane onto the level to add it. -->
      <div class="nested-level-field wf-field-drop-zone" (dragover)="host.allowFieldDrop($event)" (drop)="onColumnFieldDrop($event, level)">
        <label>Columns</label>
        <small class="control-hint" *ngIf="!level.columns.length">All columns of the rows. Add a column to pick specific ones (from any dataset), or an input box / dropdown users fill in.</small>

        <div class="nested-column-card" *ngFor="let column of level.columns; let ci = index; trackBy: trackColumn">
          <div class="nested-column-head">
            <span class="nested-column-title">{{ ci + 1 }}. {{ column.label || column.field || 'New column' }}<span class="nested-column-kind" *ngIf="column.kind !== 'data'"> · {{ column.kind === 'input' ? 'Input' : column.kind === 'dropdown' ? 'Dropdown' : column.kind === 'serial' ? 'Serial number' : 'Formula' }}</span><span class="nested-column-kind" *ngIf="column.secondField"> · + {{ column.secondField }}</span><span class="nested-column-kind" *ngIf="column.expander"> · ▾ arrow</span></span>
            <span class="nested-column-dataset" *ngIf="column.dataset && column.dataset !== host.drillDataset">{{ column.dataset }}</span>
            <!-- Arrange the columns: the table shows them in this order. -->
            <button type="button" class="nested-column-move" [disabled]="ci === 0" (click)="moveColumn(level, ci, -1)" title="Move left (up)" aria-label="Move column up">&uarr;</button>
            <button type="button" class="nested-column-move" [disabled]="ci === level.columns.length - 1" (click)="moveColumn(level, ci, 1)" title="Move right (down)" aria-label="Move column down">&darr;</button>
            <button type="button" class="nested-level-remove" (click)="removeColumn(level, column)" title="Remove column" aria-label="Remove column">&times;</button>
          </div>
          <div class="nested-level-field">
            <label>Column type</label>
            <!-- ng-select, not a native <select>: the browser sizes a native
                 popup to its longest option, so it spilled past the panel. The
                 ng-select panel keeps the control's width and the hover
                 tooltip (SsSelectTooltipDirective) shows any clipped label. -->
            <ng-select
              #ssNestedColKind
              class="ss-select"
              [class.is-open]="!!ssNestedColKind.isOpen()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="columnKinds"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [disabled]="column.kind === 'serial'"
              [ngModel]="column.kind === 'serial' ? 'data' : column.kind"
              (ngModelChange)="setColumnKind(level, column, $event)"
            ></ng-select>
          </div>
          <div class="nested-level-field">
            <label>Row marker</label>
            <ng-select
              class="ss-select"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="rowMarkerOptions"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [ngModel]="column.serialNumber || column.kind === 'serial' ? 'serial' : 'none'"
              (ngModelChange)="setRowMarker(level, column, $event)"
            ></ng-select>
            <small class="control-hint">Replace the row's expand icon with its number.</small>
          </div>
          <!-- The level's expand arrow sits in the ticked column (else the first). -->
          <label class="nested-expander" *ngIf="!isLastLevel(i) && column.kind !== 'serial'">
            <input type="checkbox" [checked]="!!column.expander" (change)="setExpander(level, column, $any($event.target).checked)" />
            Show expand arrow in this column
          </label>
          <label class="nested-expander" *ngIf="(column.kind === 'data' || column.kind === 'input' || column.kind === 'dropdown') && column.field">
            <input type="checkbox" [checked]="!!column.aggregate" (change)="setAggregationEnabled(level, column, $any($event.target).checked)" />
            Aggregate this column
          </label>
          <label class="nested-expander" *ngIf="column.kind === 'input'">
            <input type="checkbox" [checked]="!!column.numericOnly" (change)="setNumericOnly(level, column, $any($event.target).checked)" />
            Numbers only
          </label>
          <!-- Keep a typed number inside limits: a fixed number, or a column of
               the same row (e.g. floor_price / best_price) so each row has its own. -->
          <!-- Each limit: a column picked from the list (or a number typed in),
               moved by its own % — e.g. cost −10 and best_price +10. Outside
               the result the box turns red and the row cannot be saved. -->
          <div class="nested-level-field" *ngIf="column.kind === 'input'">
            <label>Minimum value (columns or number)</label>
            <ng-select
              #ssMinValue
              class="ss-select"
              [class.is-open]="!!ssMinValue.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="boundColumnOptions(level, column)"
              bindLabel="label"
              bindValue="value"
              [addTag]="addBoundNumber"
              addTagText="Use number"
              [multiple]="true"
              [closeOnSelect]="false"
              [clearable]="true"
              [searchable]="true"
              placeholder="e.g. total_cost, current_price"
              [ngModel]="boundList(column.minValue)"
              (ngModelChange)="onColumnTextChange(level, column, 'minValue', ($event || []).join(','))"
            ></ng-select>
          </div>
          <div class="nested-level-field" *ngIf="column.kind === 'input' && boundList(column.minValue).length > 1">
            <label>Minimum = the</label>
            <select [ngModel]="column.minPick || 'lowest'" (ngModelChange)="setBoundPick(level, column, 'minPick', $event)">
              <option *ngFor="let option of boundPickOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
          <div class="nested-level-field" *ngIf="column.kind === 'input' && column.minValue">
            <label>Minimum adjustment (%)</label>
            <input type="number" step="1" [ngModel]="column.minOffsetPct ?? null" (ngModelChange)="setOffsetPct(level, column, 'minOffsetPct', $event)" placeholder="e.g. -10" />
          </div>
          <div class="nested-level-field" *ngIf="column.kind === 'input'">
            <label>Maximum value (columns or number)</label>
            <ng-select
              #ssMaxValue
              class="ss-select"
              [class.is-open]="!!ssMaxValue.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="boundColumnOptions(level, column)"
              bindLabel="label"
              bindValue="value"
              [addTag]="addBoundNumber"
              addTagText="Use number"
              [multiple]="true"
              [closeOnSelect]="false"
              [clearable]="true"
              [searchable]="true"
              placeholder="e.g. target_cost, current_price"
              [ngModel]="boundList(column.maxValue)"
              (ngModelChange)="onColumnTextChange(level, column, 'maxValue', ($event || []).join(','))"
            ></ng-select>
          </div>
          <div class="nested-level-field" *ngIf="column.kind === 'input' && boundList(column.maxValue).length > 1">
            <label>Maximum = the</label>
            <select [ngModel]="column.maxPick || 'highest'" (ngModelChange)="setBoundPick(level, column, 'maxPick', $event)">
              <option *ngFor="let option of boundPickOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
          <div class="nested-level-field" *ngIf="column.kind === 'input' && column.maxValue">
            <label>Maximum adjustment (%)</label>
            <input type="number" step="1" [ngModel]="column.maxOffsetPct ?? null" (ngModelChange)="setOffsetPct(level, column, 'maxOffsetPct', $event)" placeholder="e.g. 10" />
          </div>
          <label class="nested-expander" *ngIf="column.kind === 'input' && (column.minValue || column.maxValue)">
            <input type="checkbox" [checked]="column.showBounds === true" (change)="setShowBounds(level, column, $any($event.target).checked)" />
            Show the min / max and the column each came from under the field
          </label>
          <!-- Optional message box under a value outside the range: shown only
               when text is written here; blank = just the red border. -->
          <div class="nested-level-field" *ngIf="column.kind === 'input' && (column.minValue || column.maxValue)">
            <label>Message when out of range (optional)</label>
            <input type="text" [ngModel]="column.rangeMessage" (ngModelChange)="onColumnTextChange(level, column, 'rangeMessage', $event)" placeholder="Leave empty for no message" />
            <small class="control-hint">e.g. "{{ '{label}' }} must be between {{ '{min}' }} ({{ '{minFrom}' }}) and {{ '{max}' }} ({{ '{maxFrom}' }})". {{ '{minFrom} / {maxFrom}' }} = the column each limit came from, with its %. {{ '{min} / {max}' }} = the allowed range, {{ '{value}' }} = what was typed, {{ '{label}' }} = this column's header.</small>
          </div>
          <label class="nested-expander" *ngIf="column.kind === 'data' || column.kind === 'formula'">
            <input type="checkbox" [checked]="!!column.hidden" (change)="setHidden(column, $any($event.target).checked)" />
            Hide in table (still sent to the backend)
          </label>
          <div class="nested-level-field" *ngIf="column.kind !== 'formula' && column.aggregate">
            <label>Aggregation</label>
            <ng-select
              #ssNestedAggregation
              class="ss-select"
              [class.is-open]="!!ssNestedAggregation.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="host.measureAggregations"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [ngModel]="column.aggregation || 'SUM'"
              (ngModelChange)="onColumnTextChange(level, column, 'aggregation', $event || 'SUM')"
            ></ng-select>
          </div>
          <!-- The picked aggregation's own settings (e.g. All match: match value,
               results, ignore case) - listed by the aggregation option's config. -->
          <ng-container *ngIf="column.kind !== 'formula'">
            <ng-container *ngFor="let param of aggregationParamsFor(column)">
              <div class="nested-level-field" *ngIf="param.control !== 'checkbox'">
                <label>{{ param.label }}</label>
                <input
                  type="text"
                  [ngModel]="aggregationParamValue(column, param)"
                  (ngModelChange)="setAggregationParam(level, column, param, $event)"
                  [placeholder]="param.placeholder || ''"
                />
                <small class="control-hint" *ngIf="param.hint">{{ param.hint }}</small>
              </div>
              <label class="nested-expander" *ngIf="param.control === 'checkbox'">
                <input
                  type="checkbox"
                  [checked]="aggregationParamValue(column, param) === true"
                  (change)="setAggregationParam(level, column, param, $any($event.target).checked)"
                />
                {{ param.label }}
              </label>
            </ng-container>
          </ng-container>
          <div class="nested-level-field" *ngIf="column.kind === 'data'">
            <label>Dataset column</label>
            <ng-select
              #ssNestedColField
              class="ss-select"
              [class.is-open]="!!ssNestedColField.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="combinedColumnOptions(column)"
              bindLabel="label"
              bindValue="value"
              groupBy="dataset"
              [clearable]="true"
              [searchable]="true"
              [loading]="combinedColumnsLoading()"
              [placeholder]="host.selectedDatasets.length ? 'Select a column from any selected dataset' : 'Select datasets first'"
              [ngModel]="combinedColumnValue(column)"
              (ngModelChange)="onCombinedColumnChange(level, column, $event)"
            ></ng-select>
            <small class="control-hint" *ngIf="column.dataset && column.field">Source: {{ column.dataset }}</small>
          </div>
          <!-- ONE column from TWO database columns ("Proposed Delta wrt MFN":
               6% - 10%): the second column of the same dataset is drawn in the
               same cell, after the separator. -->
          <div class="nested-level-field" *ngIf="column.kind === 'data' && column.field">
            <label>Second column (optional)</label>
            <ng-select
              #ssNestedColSecond
              class="ss-select"
              [class.is-open]="!!ssNestedColSecond.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="secondColumnsForColumn(column)"
              [clearable]="true"
              [searchable]="true"
              [loading]="isColumnLoading(column)"
              placeholder="None — one value per cell"
              [ngModel]="column.secondField || null"
              (ngModelChange)="onColumnSecondFieldChange(level, column, $event)"
            ></ng-select>
            <small class="control-hint">Shows both values in this one column, e.g. 6% - 10%.</small>
          </div>
          <div class="nested-level-field" *ngIf="column.kind === 'data' && column.secondField">
            <label>Separator</label>
            <input type="text" [ngModel]="column.separator" (ngModelChange)="onColumnTextChange(level, column, 'separator', $event)" placeholder="-" />
          </div>
          <div class="nested-level-field">
            <label>Header</label>
            <input type="text" [ngModel]="column.label" (ngModelChange)="onColumnLabelChange(column, $event)" [placeholder]="column.field || 'Header label'" />
          </div>
          <div class="nested-level-field">
            <label>Width (px)</label>
            <input type="number" min="40" step="10" [ngModel]="column.width ?? null" (ngModelChange)="setWidth(level, column, $event)" placeholder="Auto" />
            <small class="control-hint">Blank = automatic, or the Format tab's Header width for this level. A width here always wins.</small>
          </div>
          <label class="nested-expander" title="Money column: shown × the rate selected in the Currency exchange dropdown. Display only.">
            <input type="checkbox" [ngModel]="!!column.convertCurrency" (ngModelChange)="setConvertCurrency(level, column, $event)" />
            Convert currency (follows the exchange rate)
          </label>
          <div class="nested-level-field" *ngIf="column.kind === 'data' || column.kind === 'formula' || column.kind === 'input'">
            <label>Round off</label>
            <!-- ng-select (panel stays the control's width; long labels get the
                 hover tooltip) - a native <select> popup spilled past the panel. -->
            <ng-select
              #ssNestedRoundOff
              class="ss-select"
              [class.is-open]="!!ssNestedRoundOff.isOpen()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="roundOffChoices"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [ngModel]="column.decimals ?? noRounding"
              (ngModelChange)="setDecimals(level, column, $event)"
            ></ng-select>
            <small class="control-hint">Numbers in this column are rounded to these decimal places; text is left as is.</small>
          </div>
          <div class="nested-level-field" *ngIf="column.kind === 'data' || column.kind === 'formula'">
            <label>Number scale</label>
            <ng-select
              #ssNestedScale
              class="ss-select"
              [class.is-open]="!!ssNestedScale.isOpen()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="scaleChoices"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [ngModel]="column.scale ?? noScale"
              (ngModelChange)="setScale(level, column, $event)"
            ></ng-select>
            <small class="control-hint">e.g. 23,037,142 shows as 23.0M - one decimal unless Round off says otherwise.</small>
          </div>
          <div class="nested-level-field" *ngIf="column.kind === 'formula'">
            <label>Formula</label>
            <textarea rows="2" [ngModel]="column.formula" (ngModelChange)="onColumnTextChange(level, column, 'formula', $event)" placeholder="([sales_2026] - [cost_2026]) / [sales_2026] * 100"></textarea>
            <small class="control-hint">Use the display names of other columns in square brackets.</small>
          </div>

          <div class="nested-level-field" *ngIf="column.kind === 'data'">
            <label>Column filters</label>
            <small class="control-hint">Use a static value such as 2026, or a row token such as <code>[customer]</code> or <code>[segment]</code>.</small>
            <div class="nested-column-card" *ngFor="let filter of column.filters; trackBy: trackFilter">
              <div class="nested-column-head">
                <span class="nested-column-title">Filter</span>
                <button type="button" class="nested-level-remove" (click)="removeColumnFilter(column, filter)" aria-label="Remove column filter">&times;</button>
              </div>
              <div class="nested-level-field">
                <label>Dataset</label>
                <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="host.entityOptions" [loading]="host.entitiesLoading" [clearable]="true" [ngModel]="filter.dataset || host.drillDataset || null" (ngModelChange)="setFilter(filter, { dataset: $event || '' })"></ng-select>
              </div>
              <div class="nested-level-field">
                <label>Field</label>
                <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="columnsForFilter(filter)" [loading]="isFilterLoading(filter)" [clearable]="true" [ngModel]="filter.field || null" (ngModelChange)="setFilter(filter, { field: $event || '' })"></ng-select>
              </div>
              <div class="control-row">
                <div class="control-group"><label>Operator</label><select class="nested-kind" [ngModel]="filter.operator" (ngModelChange)="setFilter(filter, { operator: $event })"><option *ngFor="let operator of filterOperators" [value]="operator">{{ operator }}</option></select></div>
                <div class="control-group"><label>Value</label><input type="text" [ngModel]="filter.value" (ngModelChange)="setFilter(filter, { value: $event })" placeholder="2026 or [customer]" /></div>
              </div>
            </div>
            <button type="button" class="nested-column-add" (click)="addColumnFilter(column)">+ Add column filter</button>
          </div>
          <!-- NAVIGATION — right under the header name: click a value of this
               column (at this level) → open a published dashboard filtered on
               that row. -->
          <div class="nested-level-field nested-column-config" *ngIf="column.kind === 'data' ? column.field : columnKey(column)">
            <app-table-cell-config-editor
              [navigationAccordion]="true"
              title="Navigation"
              [config]="column.cellConfig"
              [fields]="navigationFields(level)"
              (configChange)="onColumnCellConfigChange(level, column, $event)"
            ></app-table-cell-config-editor>
          </div>
          <!-- Editable columns need no dataset: a key for the typed value (sent
               by action buttons) and, for a dropdown, its choices. -->
          <ng-container *ngIf="column.kind === 'input' || column.kind === 'dropdown'">
            <div class="nested-level-field">
              <label>Column (field key)</label>
              <!-- A dataset column: its saved value shows in the box by default.
                   A new name (type it) is a column the data does not have yet. -->
              <ng-select
                #ssEditorField
                class="ss-select"
                [class.is-open]="!!ssEditorField.isOpen?.()"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="columnOptions"
                [addTag]="true"
                addTagText="Use new key"
                [clearable]="true"
                [searchable]="true"
                [placeholder]="columnKey(column) || 'Select a column'"
                [ngModel]="column.field || null"
                (ngModelChange)="onColumnTextChange(level, column, 'field', $event || '')"
              ></ng-select>
            </div>
            <div class="nested-level-field" *ngIf="column.kind === 'dropdown'">
              <label>Options (comma-separated)</label>
              <input type="text" [ngModel]="column.options" (ngModelChange)="onColumnTextChange(level, column, 'options', $event)" placeholder="Approve, Reject, Hold" />
            </div>
            <!-- Two boxes in one cell ("[ 6% ] - [ 10% ]"): the second value is
                 stored under its own key and sent with the first. A dataset
                 column prefills its box like the first key does. -->
            <div class="nested-level-field">
              <label>Second column (optional)</label>
              <ng-select
                #ssEditorSecond
                class="ss-select"
                [class.is-open]="!!ssEditorSecond.isOpen?.()"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="columnOptions"
                [addTag]="true"
                addTagText="Use new key"
                [clearable]="true"
                [searchable]="true"
                placeholder="None — one box per cell"
                [ngModel]="column.secondField || null"
                (ngModelChange)="onColumnTextChange(level, column, 'secondField', $event || '')"
              ></ng-select>
              <small class="control-hint">Shows a second box in this column, e.g. [ 6% ] - [ 10% ].</small>
            </div>
            <div class="nested-level-field" *ngIf="column.secondField">
              <label>Separator</label>
              <input type="text" [ngModel]="column.separator" (ngModelChange)="onColumnTextChange(level, column, 'separator', $event)" placeholder="-" />
            </div>
            <label class="nested-expander">
              <input type="checkbox" [checked]="!!column.required" (change)="setColumnRequired(level, column, $any($event.target).checked)" />
              Mandatory (the row's Save shows only once this is filled)
            </label>
            <label class="nested-expander" title="The box and its value show, but users cannot change it">
              <input type="checkbox" [checked]="!!column.readOnly" (change)="setColumnReadOnly(level, column, $any($event.target).checked)" />
              Read-only (shown in the box, cannot be edited)
            </label>
          </ng-container>
          <!-- GENERIC cell configuration — the ONE editor shared with the
               Table & Matrix columns / Drill-Down measures. -->
          <div class="nested-column-config" *ngIf="column.kind === 'data' ? column.field : columnKey(column)">
            <app-table-cell-config-editor
              title="Cell formatting"
              [showNavigation]="false"
              [config]="column.cellConfig"
              [fields]="levelFields(level)"
              [values]="columnValues(level, column)"
              [loadValues]="columnValuesLoader(column)"
              [showEditor]="true"
              [showOptions]="column.cellConfig?.editor === 'dropdown'"
              valueKind="text"
              (configChange)="onColumnCellConfigChange(level, column, $event)"
            ></app-table-cell-config-editor>
          </div>
        </div>

        <button type="button" class="nested-column-add" (click)="addColumn(level)">+ Add column</button>
      </div>

      <div class="nested-level-field">
        <label>Level filters</label>
        <small class="control-hint">Fixed filters for the complete request of this level.</small>
        <div class="nested-column-card" *ngFor="let filter of level.filters; trackBy: trackFilter">
          <div class="nested-column-head">
            <span class="nested-column-title">Filter</span>
            <button type="button" class="nested-level-remove" (click)="removeLevelFilter(level, filter)" aria-label="Remove level filter">&times;</button>
          </div>
          <div class="nested-level-field">
            <label>Dataset</label>
            <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="host.entityOptions" [loading]="host.entitiesLoading" [clearable]="true" [ngModel]="filter.dataset || host.drillDataset || null" (ngModelChange)="setFilter(filter, { dataset: $event || '' })"></ng-select>
          </div>
          <div class="nested-level-field">
            <label>Field</label>
            <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="columnsForFilter(filter)" [loading]="isFilterLoading(filter)" [clearable]="true" [ngModel]="filter.field || null" (ngModelChange)="setFilter(filter, { field: $event || '' })"></ng-select>
          </div>
          <div class="control-row">
            <div class="control-group"><label>Operator</label><select class="nested-kind" [ngModel]="filter.operator" (ngModelChange)="setFilter(filter, { operator: $event })"><option *ngFor="let operator of filterOperators" [value]="operator">{{ operator }}</option></select></div>
            <div class="control-group"><label>Value</label><input type="text" [ngModel]="filter.value" (ngModelChange)="setFilter(filter, { value: $event })" placeholder="Hitachi or [customer]" /></div>
          </div>
        </div>
        <button type="button" class="nested-column-add" (click)="addLevelFilter(level)">+ Add level filter</button>
      </div>

      <div class="control-row">
        <div class="control-group">
          <label>Sort by</label>
          <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="sortOptions(level)" [clearable]="true" [ngModel]="level.sortField || null" (ngModelChange)="level.sortField = $event || ''; onFieldChange()"></ng-select>
        </div>
        <div class="control-group" *ngIf="level.sortField">
          <label>Direction</label>
          <select class="nested-kind" [(ngModel)]="level.sortDirection" (ngModelChange)="onFieldChange()"><option value="DESC">Descending</option><option value="ASC">Ascending</option></select>
        </div>
      </div>
      <label class="nested-expander">
        <input type="checkbox" [(ngModel)]="level.paginationEnabled" (ngModelChange)="onFieldChange()" />
        Enable pagination for this level
      </label>

      <!-- Save (update): a Save on each edited row sends the update request —
           only the entity and the business keys (+ the row's input / dropdown
           values) change; the rest of the body is fixed. -->
      <div class="nested-level-field">
        <label class="nested-expander">
          <input type="checkbox" [checked]="level.rowSave.enabled" (change)="setRowSave(level, { enabled: $any($event.target).checked })" />
          Save button on edited rows (update)
        </label>
        <ng-container *ngIf="level.rowSave.enabled">
          <div class="nested-level-field">
            <label>Button name</label>
            <input type="text" [ngModel]="level.rowSave.label" (ngModelChange)="setRowSave(level, { label: $event })" placeholder="Save" />
          </div>
          <div class="nested-level-field">
            <label>Save API URL</label>
            <input type="text" [ngModel]="level.rowSave.url" (ngModelChange)="setRowSave(level, { url: $event })" placeholder="/api/…" />
          </div>
          <div class="nested-level-field">
            <label>Entity</label>
            <ng-select
              #ssEntity
              class="ss-select"
              [class.is-open]="!!ssEntity.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="host.entityOptions"
              [loading]="host.entitiesLoading"
              [addTag]="true"
              [clearable]="true"
              [searchable]="true"
              [placeholder]="host.drillDataset ? 'Same as the dataset (' + host.drillDataset + ')' : 'Select an entity'"
              [ngModel]="level.rowSave.entity || null"
              (ngModelChange)="setRowSaveEntity(level, $event)"
            ></ng-select>
          </div>
          <div class="nested-level-field">
            <label>Business keys</label>
            <ng-select
              #ssBizKeys
              class="ss-select"
              [class.is-open]="!!ssBizKeys.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="bizKeyOptions(level)"
              [multiple]="true"
              [addTag]="true"
              [clearable]="true"
              [searchable]="true"
              [loading]="host.isDatasetColumnsLoading(level.rowSave.entity || host.drillDataset)"
              placeholder="Select the business keys"
              [ngModel]="level.rowSave.businessKeys"
              (ngModelChange)="setRowSave(level, { businessKeys: $event || [] })"
            ></ng-select>
            <small class="control-hint">Each key is sent with its value — taken from the edited row, or from the row it opened under when that level holds it (e.g. cust_type on level 1).</small>
          </div>
          <div class="nested-level-field">
            <label>Columns to send</label>
            <ng-select
              #ssPayloadCols
              class="ss-select"
              [class.is-open]="!!ssPayloadCols.isOpen?.()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="payloadColumnOptions(level)"
              [multiple]="true"
              [addTag]="true"
              [clearable]="true"
              [searchable]="true"
              placeholder="All edited columns"
              [ngModel]="level.rowSave.payloadColumns"
              (ngModelChange)="setRowSave(level, { payloadColumns: $event || [] })"
            ></ng-select>
            <small class="control-hint">Of these, only the ones the user edited in that row are sent — edit one, one is sent; edit several, all of them. Empty = every edited column.</small>
          </div>
        </ng-container>
      </div>

      <!-- Buttons above this level's table (like Export / Planning View), left
           to right in the order added. Each one navigates, calls an API or
           exports the table. -->
      <div class="nested-level-field">
        <label>Buttons</label>
        <small class="control-hint" *ngIf="!level.buttons.length">None yet. Add one to show it above this level's table.</small>
        <div class="nested-column-card" *ngFor="let button of level.buttons; let bi = index; trackBy: trackButton">
          <div class="nested-column-head">
            <span class="nested-column-title">{{ bi + 1 }}. {{ button.label || 'Button' }}</span>
            <button type="button" class="nested-column-move" [disabled]="bi === 0" (click)="moveButton(level, bi, -1)" title="Move left" aria-label="Move button left">&larr;</button>
            <button type="button" class="nested-column-move" [disabled]="bi === level.buttons.length - 1" (click)="moveButton(level, bi, 1)" title="Move right" aria-label="Move button right">&rarr;</button>
            <button type="button" class="nested-level-remove" (click)="removeButton(level, button)" title="Remove button" aria-label="Remove button">&times;</button>
          </div>
          <div class="nested-level-field">
            <label>Button name</label>
            <input type="text" [ngModel]="button.label" (ngModelChange)="setButton(level, button, { label: $event })" placeholder="e.g. Planning View" />
          </div>
          <div class="nested-level-field">
            <label>Style</label>
            <select class="nested-kind" [ngModel]="button.style" (ngModelChange)="setButton(level, button, { style: $event })">
              <option value="outline">Outline</option>
              <option value="filled">Filled</option>
            </select>
          </div>
          <div class="nested-level-field">
            <label>When clicked</label>
            <ng-select
              #ssNestedBtnAction
              class="ss-select"
              [class.is-open]="!!ssNestedBtnAction.isOpen()"
              appendTo="body"
              ngClass="ss-dropdown-panel"
              [items]="buttonActionOptions"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [ngModel]="button.action"
              (ngModelChange)="setButton(level, button, { action: $event })"
            ></ng-select>
          </div>
          <ng-container *ngIf="button.action === 'excel'">
            <div class="nested-level-field">
              <label>URL</label>
              <input type="text" [ngModel]="button.apiUrl" (ngModelChange)="setButton(level, button, { apiUrl: $event })" [placeholder]="excelDefaultUrl" />
            </div>
            <div class="nested-level-field">
              <label>Filter columns</label>
              <ng-select
                #ssExcelFilterCols
                class="ss-select"
                [class.is-open]="!!ssExcelFilterCols.isOpen?.()"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="excelFilterColumnOptions(button)"
                [multiple]="true"
                [closeOnSelect]="false"
                [clearable]="true"
                [searchable]="true"
                [loading]="host.isDatasetColumnsLoading(host.drillDataset)"
                placeholder="None = every dashboard selection"
                [ngModel]="button.filterColumns"
                (ngModelChange)="setButton(level, button, { filterColumns: $event || [] })"
              ></ng-select>
              <small class="control-hint">
                Each column is sent as a filter with the value of the row this table opened under, else what is selected for it on the
                dashboard; a column with no value is skipped. None picked = every dashboard selection on this dataset's columns.
              </small>
            </div>
            <div class="nested-level-field">
              <label>Sheet name</label>
              <input type="text" [ngModel]="button.sheetName" (ngModelChange)="setButton(level, button, { sheetName: $event })" placeholder="Sheet1" />
            </div>
            <div class="nested-level-field">
              <label>Body (JSON)</label>
              <textarea rows="8" [ngModel]="button.apiBody" (ngModelChange)="setButton(level, button, { apiBody: $event })"></textarea>
              <small class="control-hint">
                Tokens: <code>{{ '{entity}' }}</code> this table's dataset, <code>{{ '{filters}' }}</code> the filter list built from the columns above,
                <code>{{ '{fileName}' }}</code>, <code>{{ '{sheetName}' }}</code>, <code>{{ '{userEmail}' }}</code>. The .xlsx in the response is downloaded.
              </small>
            </div>
          </ng-container>
          <ng-container *ngIf="button.action === 'navigate'">
            <div class="nested-level-field">
              <label>Go to</label>
              <ng-select
                #ssNestedNavType
                class="ss-select"
                [class.is-open]="!!ssNestedNavType.isOpen()"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="navigateTypeOptions"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [searchable]="false"
                [ngModel]="button.navigateType"
                (ngModelChange)="setButton(level, button, { navigateType: $event })"
              ></ng-select>
            </div>
            <div class="nested-level-field">
              <label>{{ button.navigateType === 'url' ? 'URL' : button.navigateType === 'dashboard' ? 'Dashboard id' : 'Route' }}</label>
              <input type="text" [ngModel]="button.navigateTarget" (ngModelChange)="setButton(level, button, { navigateTarget: $event })"
                [placeholder]="button.navigateType === 'url' ? 'https://…' : button.navigateType === 'dashboard' ? 'e.g. planning-view' : 'e.g. /reports/specs'" />
            </div>
            <label class="nested-expander">
              <input type="checkbox" [checked]="button.navigateNewTab" (change)="setButton(level, button, { navigateNewTab: $any($event.target).checked })" />
              Open in a new tab
            </label>
          </ng-container>
          <ng-container *ngIf="button.action === 'api'">
            <div class="nested-level-field">
              <label>Method</label>
              <select class="nested-kind" [ngModel]="button.apiMethod" (ngModelChange)="setButton(level, button, { apiMethod: $event })">
                <option *ngFor="let method of ['POST', 'PUT', 'PATCH', 'GET', 'DELETE']" [value]="method">{{ method }}</option>
              </select>
            </div>
            <div class="nested-level-field">
              <label>URL</label>
              <input type="text" [ngModel]="button.apiUrl" (ngModelChange)="setButton(level, button, { apiUrl: $event })" placeholder="/api/…" />
            </div>
            <div class="nested-level-field">
              <label>Body (JSON)</label>
              <textarea rows="3" [ngModel]="button.apiBody" (ngModelChange)="setButton(level, button, { apiBody: $event })"
                placeholder='{ "rows": "{rows}", "parent": "{parentRow}", "edits": "{tableEdits}" }'></textarea>
              <small class="control-hint">Tokens: <code>{{ '{' }}rows{{ '}' }}</code> this table's rows, <code>{{ '{' }}parentRow{{ '}' }}</code> the row it opened under, <code>{{ '{' }}tableEdits{{ '}' }}</code> typed values.</small>
            </div>
          </ng-container>
        </div>
        <button type="button" class="nested-column-add" (click)="addButton(level)">+ Add button</button>
      </div>
    </div>

    <button type="button" class="nested-level-add" [disabled]="levels.length >= maxLevels" (click)="addLevel()">
      + Add level
    </button>
  </div>

  <ng-container *ngTemplateOutlet="chartFormatAccordion"></ng-container>

  <!-- Sorting: each level's row order, applied in the table. Rule 1 decides first,
       each next rule only breaks ties; a rule with two or more columns sorts on their sum. -->
  <div class="dvm-format-group" [class.is-open]="sortingOpen">
    <button type="button" class="dvm-format-group-head" (click)="sortingOpen = !sortingOpen">
      <span>Sorting</span>
      <mat-icon>{{ sortingOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    <div class="dvm-format-group-body" *ngIf="sortingOpen">
      <small class="control-hint">Order each level's rows: rule 1 decides first, each next rule only breaks ties. Pick two or more columns in a rule to sort by their sum.</small>
      <div class="nested-level-field" *ngFor="let level of levels; let li = index">
        <label>Level {{ li + 1 }}{{ level.title ? ' - ' + level.title : '' }}</label>
        <div class="nested-column-card" *ngFor="let rule of level.sortRules ?? []; let ri = index">
          <div class="nested-column-head">
            <span class="nested-column-title">{{ ri === 0 ? 'Sort by' : 'Then by' }}</span>
            <button type="button" class="nested-level-remove" *ngIf="ri > 0" (click)="moveSortRule(level, ri)" aria-label="Move up">↑</button>
            <button type="button" class="nested-level-remove" (click)="removeSortRule(level, ri)" aria-label="Remove sort rule">&times;</button>
          </div>
          <div class="control-row">
            <div class="control-group">
              <label>Column(s)</label>
              <ng-select
                class="ss-select"
                appendTo="body"
                ngClass="ss-dropdown-panel"
                [items]="sortOptions(level)"
                [multiple]="true"
                [clearable]="true"
                placeholder="Pick a column"
                [ngModel]="rule.columns"
                (ngModelChange)="setSortRule(level, ri, { columns: $event ?? [] })"
              ></ng-select>
            </div>
            <div class="control-group">
              <label>Direction</label>
              <select class="nested-kind" [ngModel]="rule.direction" (ngModelChange)="setSortRule(level, ri, { direction: $event })">
                <option value="desc">Highest first (descending)</option>
                <option value="asc">Lowest first (ascending)</option>
              </select>
            </div>
          </div>
        </div>
        <button type="button" class="nested-column-add" (click)="addSortRule(level)">+ Add sort rule</button>
        <label class="nested-expander">
          <input type="checkbox" [(ngModel)]="level.headerSort" (ngModelChange)="onFieldChange()" />
          Also let users sort by clicking a column header
        </label>
      </div>
    </div>
  </div>
</div>
